import React, { useRef, useState, useEffect, useMemo} from 'react';

import Stories from '../components/Swiper/Stories';

const MasDeUstedes = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openStories = (index) => {
    setActiveIndex(index);
    setIsModalOpen(true);
  };

  return (
    <div>
      <div style={{"text-align": "center", "padding": "4rem 0 4rem 0", "backgroundColor": "#ffffff", "color": "#1f2a4e", "height": "fit-content", }}>
              <div className="header-seccion" style={{padding: "0rem 6rem !important"}}>
                <h1 className='bold'>
                  Gente que suma🤍
              </h1>
              <p className='text-md'>
                  Detrás de nuestra historia de amor, hay manos que nos han sostenido y corazones que nos han guiado. Con gratitud y cariño, les presentamos a nuestra corte de honor: las personas que han hecho posible que hoy estemos aquí.
              </p>
              </div>
              
              <Stories/>
          </div>
    </div>
  );
};

export default MasDeUstedes;